import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppInfoService } from 'core/app-info/app-info.service';
import { UserInfo } from 'core/app-info/user-info.class';
import { AppStateService } from 'core/app-state/app-state.service';
import { AuthenticationService } from 'core/authentication/authentication.service';
import { currencies, dateFormats, dateLocales, dateTimeFormats, weightUnits } from 'core/app-info/country-specifics.enum';
import { AppLocalization } from '../entities/app-localization';

@Component({
  selector: 'app-offline-login-screen',
  templateUrl: './offline-login-screen.component.html',
  styleUrls: ['./offline-login-screen.component.scss'],
  standalone: false
})
export class OfflineLoginScreenComponent implements OnInit {
  offlineToken = '';
  appStrings: AppLocalization;
  userData: UserInfo;
  error: string;
  showLogin = true;

  constructor(
    private appInfoService: AppInfoService,
    private appStateService: AppStateService,
    private authService: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.userData = this.appInfoService.userData;
  }

  submitLogin() {
    this.error = '';
    const encodedToken = btoa(this.offlineToken);
    this.appInfoService.validateOfflineUserInfo(encodedToken)
      .subscribe(token => this.authSuccessfully(token), error => this.authError(error));
  }

  toggleForgotPasswordScreen() {
    this.showLogin = !this.showLogin;
  }

  goOnline() {
    if (this.appStateService.state.isInternetConnected) {
      this.appStateService.goOnline();
    } else {
      this.router.navigate(['/no-internet']);
    }
  }

  private authSuccessfully(offlineToken: string) {
    this.authService.authenticateOffline(offlineToken);
    this.appInfoService.initializeUserData().subscribe(userData => {
      this.appInfoService.userData = this.appInfoService.parseAccessAndModules(userData);
      if (userData) {
        this.appInfoService.dateFormat = dateFormats[this.appInfoService.userData.UserInfo.CountryCode] || dateFormats.US;
        this.appInfoService.dateTimeFormat = dateTimeFormats[this.appInfoService.userData.UserInfo.CountryCode] || dateTimeFormats.US;
        this.appInfoService.currencySymbol = currencies[this.appInfoService.userData.UserInfo.CountryCode] || currencies.US;
        this.appInfoService.weightSymbol = weightUnits[this.appInfoService.userData.UserInfo.CountryCode] || weightUnits.US;
        this.appInfoService.dateLocale = dateLocales[this.appInfoService.userData.UserInfo.CountryCode] || dateLocales.US;
      }
      this.router.navigate(['/']);
    });
  }

  private authError(errorObj) {
    this.error = errorObj.error;
  }

}
